export default "/images/anchor.svg?7af672693c22d4ab02902065f7cf403f";